
<ng-container *ngIf="profiles === undefined">
  <spinner></spinner>
</ng-container>
<ng-container *ngIf="profiles !== undefined">
  <div class="form-group">
    <label translate>Profiles</label>
    <entity-list [entities]="profiles" className="list-group list-group-light" [filterKeys]="['name']">
      <ng-template entityListItem let-profile="entity">
        <checkbox [checked]="options.proxyProfiles.includes(profile.id)" (click)="toggleProfile(profile)" [text]="profile.name"></checkbox>
      </ng-template>
    </entity-list>
  </div>
  <div class="form-group">
    <label translate>Options</label>
    <div>
      <checkbox [(ngModel)]="options.enqueueAtFront" [text]="&quot;Use priority queue&quot;|translate"></checkbox>
    </div>
    <div>
      <checkbox [(ngModel)]="options.retryFailed" [disabled]="options.force" [text]="&quot;Retry previously failed proxies&quot;|translate"></checkbox>
      <new-badge version="23.5"></new-badge>
    </div>
    <div>
      <checkbox [(ngModel)]="options.force" (ngModelChange)="onUpdate()" [text]="&quot;Regenerate existing proxies&quot;|translate"></checkbox>
    </div>
  </div>
</ng-container>